import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/notifications-log")({
  component: lazyRouteComponent(() => import("./-pages/admin.notifications-log")),
  head: () => ({
    meta: [
      { title: "Notifications Log · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
